<ng-container *ngrxLet="remoteDiagnosticsSnapshotsStore.showSnapshotsLoader$ | async as loader">
  <!-- loader -->
  <vi-loader
    *ngIf="loader"
    data-at-loader
    message="{{ '+REMOTE_DIAGNOSTICS_BACKUPS.LOADER.LOADING_BACKUPS_TEXT' | translate }}"
    [isLoading]="true"
  >
  </vi-loader>
  <!-- snapshot list -->
  <div *ngIf="!loader" class="snapshot-list-container flex flex-col">
    <div class="snapshot-list-header flex flex-row lt-lg:flex-col justify-between items-center">
      <div
        class="add-snapshot-btn-container flex flex-row lt-md:flex-col justify-start items-center lt-md:items-start"
      >
        <h2 class="all-snapshots-header">
          {{ '+REMOTE_DIAGNOSTICS_SNAPSHOTS.LABEL.SNAPSHOT_LIST' | translate }}
        </h2>
        <button
          class="create-snapshot-btn btn-lt-md"
          gtm="onStart"
          gtmAction="create new snapshot open diagnostics modal"
          gtmCategory="vddSnapshots"
          mat-raised-button
          color="primary"
          (click)="createSnapshot()"
          [disabled]="!isActiveSessionAvailable"
        >
          <mat-icon class="icon">add</mat-icon
          >{{ '+REMOTE_DIAGNOSTICS_SNAPSHOTS.BTN.CREATE_SNAPSHOT' | translate }}
        </button>
      </div>
      <app-month-datepicker
        class="datepicker thick-border"
        gtmCategory="vddSnapshots"
        gtm="onSelect"
        gtmAction="Select Month"
        [minDate]="(gatewayProperties$ | async)?.registeredAt"
        (dateChanged)="changeDate($event)"
      ></app-month-datepicker>
    </div>
    <div class="divider"></div>
    <ng-container *ngIf="displayedSnapshots.length; else noSnapshots">
      <div
        class="snapshots-container !flex flex-row flex-wrap gap-[12px] justify-start items-center lt-md:justify-center grid"
      >
        <app-backup-item
          class="full-width"
          *ngFor="let snapshot of displayedSnapshots"
          [backup]="snapshot"
        >
        </app-backup-item>
      </div>
      <button
        gtm="onToggle"
        gtmAction="expand or collapse backups"
        gtmCategory="vddSnapshots"
        mat-button
        color="primary"
        (click)="toggleShowMoreBackups()"
      >
        <!-- +REMOTE_DIAGNOSTICS_SNAPSHOTS.BTN.RESET_FILTER -->
        <ng-template
          [ngIf]="remoteDiagnosticsSnapshotsStore.isShowingMoreSnapshots$ | async"
          [ngIfElse]="collapseIcon"
        >
          <span>{{ 'GENERAL.BUTTON.SHOW_LESS' | translate }}</span>
          <mat-icon class="arrow-icon">keyboard_arrow_up</mat-icon>
        </ng-template>
        <ng-template #collapseIcon>
          {{ 'GENERAL.BUTTON.SHOW_MORE' | translate }}
          <mat-icon #collapseIcon class="arrow-icon">keyboard_arrow_down</mat-icon>
        </ng-template>
      </button>
    </ng-container>
  </div>
</ng-container>

<ng-template #noSnapshots>
  <div class="flex flex-col justify-center items-center">
    <h2>
      {{ '+REMOTE_DIAGNOSTICS_SNAPSHOTS.LABEL.NO_SNAPSHOTS_FOUND' | translate }}
    </h2>
    <vi-text class="sub-header">
      {{ '+REMOTE_DIAGNOSTICS_SNAPSHOTS.LABEL.CLICK_BUTTON_TO_ADD_SNAPSHOT' | translate }}
    </vi-text>
    <button
      class="create-snapshot-btn"
      gtm="onStart"
      gtmAction="create new snapshot open diagnostics modal"
      gtmCategory="vddSnapshots"
      mat-raised-button
      color="primary"
      (click)="createSnapshot()"
      [disabled]="!isActiveSessionAvailable"
    >
      <mat-icon class="icon">add</mat-icon
      >{{ '+REMOTE_DIAGNOSTICS_SNAPSHOTS.BTN.CREATE_SNAPSHOT' | translate }}
    </button>
  </div>
</ng-template>
